import { useFormik } from "formik";
import React, { useState, useEffect, useMemo } from "react";
import { Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategoryById,
  updateCategory,
} from "../../../redux/category/action";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { addcategary } from "../../Constant/constant";
import UploadImage from "./UploadImage";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";


const formData = [
  { title: "Gender", name: "gender" },
  { title: "Title", name: "title" },
  { title: "Arabic Title", name: "ar_title" },
  { title: "Position", name: "position" },
  { title: "Select Homeview", name: "home_view" },
  { title: "Status", name: "status" },
  { title: "Image", name: "image" },
];

const AddCategory = (props) => {
  const [gender, setGender] = useState(1);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(
    ({ category: { categorybyid } }) => categorybyid
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(getCategoryById(id));
      setUpdate(true);
    }
  }, [dispatch, id]);

  const initialValues = useMemo(() => {
    const values = formData.reduce((acc, field) => {
      acc[field.name] = selectedCustomer?.[field.name] || "";
      return acc;
    }, {});

    values.gender = selectedCustomer?.gender || 1;
    values.home_view = selectedCustomer?.home_view ?? true;
    values.status = selectedCustomer?.status ?? 1;

    return values;
  }, [selectedCustomer]);

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (value) => handleSubmit(value),
    enableReinitialize: true,
    validationSchema: addcategary(),
  });

  const validateImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          if (img.width <= 86 && img.height <= 86) {
            resolve(true);
          } else {
            reject(
              "Invalid image dimensions. The image must be lessthen 86x86 pixels."
            );
          }
        };
      };
      reader.onerror = () => reject("Error reading the image file.");
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    if (selectedFile) {
      try {
        await validateImageDimensions(selectedFile);
      } catch (err) {
        formik.setFieldError("image", err);
        setLoading(false);
        return;
      }
      try {
        const data = {
          ...values,
          id: id,
        };
        dispatch(updateCategory(data, setLoading, navigate));
        setUpdate(false);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    } else {
      const data = {
        ...values,
        id: id,
      };
      dispatch(updateCategory(data, setLoading, navigate));
      setUpdate(false);
    }
  };

  return (
    <div className=" category-wrapper">
      <div>
        <AddUpdateHeader modal={"Update Category"} list={"Category List"} />
        <div className="">
          <form onSubmit={formik.handleSubmit}>
            <Row>
              {formData.map((prop, key) => {
                switch (prop.name) {
                  case "gender": {
                    const options = [
                      { value: 1, label: ("Male") },
                      { value: 2, label: ("Female") },
                      // { value: 3, label: t("Both") },
                    ];

                    return (
                      <Col className=" " key={key} xs={3}>
                        <label>{(prop.title)}</label>
                        <div>
                          <ReactSelect
                            value={options.find(
                              (option) =>
                                option.value == formik.values?.[prop.name]
                            )}
                            placeholder={(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            options={options}
                            onChange={(option) => {
                              formik.setFieldValue("gender", option?.value);
                              setGender(option?.value);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      </Col>
                    );
                  }
                  case "home_view": {
                    const options = [
                      { value: true, label: "Display" },
                      { value: false, label: `Don't Display` },
                    ];

                    return (
                      <Col className=" " key={key} xs={3}>
                        <label>{(prop.title)}</label>
                        <div>
                          <ReactSelect
                            value={options.find(
                              (option) =>
                                option.value == formik.values?.[prop.name]
                            )}
                            placeholder={(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            options={options}
                            onChange={(options) => {
                              formik.setFieldValue("home_view", options?.value);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      </Col>
                    );
                  }
                  case "position": {
                    const options = Array.from({ length: 100 }, (_, i) => ({
                      value: i + 1,
                      label: i + 1,
                    }));

                    return (
                      <Col className=" " key={key} xs={3}>
                        <label>{(prop.title)}</label>
                        <div>
                          <ReactSelect
                            value={options.find(
                              (option) =>
                                option.value == formik.values?.[prop.name]
                            )}
                            placeholder={(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            options={options}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                prop.name,
                                selectedOption?.value
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      </Col>
                    );
                  }
                  case "status": {
                    const options = [
                      { value: 1, label: ("Active") },
                      { value: 2, label: ("Inactive") },
                    ];

                    return (
                      <Col className=" " xs={3} key={key}>
                        <label>{(prop.title)}</label>
                        <div>
                          <ReactSelect
                            value={options.find(
                              (option) =>
                                option.value == formik.values?.[prop.name]
                            )}
                            placeholder={(prop.title)}
                            id={prop.name}
                            name={prop.name}
                            options={options}
                            onChange={(options) => {
                              formik.setFieldValue("status", options?.value);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched[prop.name] &&
                            formik.errors[prop.name] && (
                              <div className="error">
                                {(formik.errors[prop.name])}
                              </div>
                            )}
                        </div>
                      </Col>
                    );
                  }
                  case "image": {
                    return (
                      <UploadImage
                        files={selectedFile}
                        setFiles={setSelectedFile}
                        update={update}
                        prop={prop}
                        formik={formik}
                      />
                    );
                  }
                  default: {
                    return (
                      <Col className=" " key={key} xs={3}>
                        <div>
                          <label>{(prop.title)}</label>
                          <CustomInput
                            value={formik.values?.[prop.name]}
                            placeholder={prop.title}
                            id={prop.name}
                            style={{
                              direction:
                                prop.name == "ar_title" ? "rtl" : "ltr",
                            }}
                            name={prop.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            touched={formik.touched}
                            errors={formik.errors}
                          />
                        </div>
                        {formik.touched[prop.name] &&
                          formik.errors[prop.name] && (
                            <div className="error">
                              {(formik.errors[prop.name])}
                            </div>
                          )}
                      </Col>
                    );
                  }
                }
              })}
              <Col
                xs={12}
                className="text-center  back-update justify-content-between"
              >
                <button
                  className="back-btn"
                  disabled={loading}
                  onClick={() => navigate("/category")}
                  type="submit"
                >
                  Back
                </button>
                <button className="submit-btn" disabled={loading} type="submit">
                  {!loading ? "Update" : <Spinner />}
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
